import { createFileRoute, redirect, useNavigate, useRouter } from '@tanstack/react-router';
import { useAuthStore } from '@/stores/auth.store';
import { EstimateDocTemplateEditor } from '@/components/documents/estimates/templateBuilder/EstimateDocTemplateEditor';
import {
  buildDefaultEstimateLayout,
  buildDefaultInvoiceLayout,
} from '@/components/documents/estimates/templateBuilder/defaultLayout';
import { useCreateEstimateDocTemplate } from '@/hooks/estimateDocTemplates';

type NewDesignSearch = { docType: 'ESTIMATE' | 'INVOICE' };

export const Route = createFileRoute('/_dashboard/dashboard/settings/document-templates/new')({
  validateSearch: (search): NewDesignSearch => ({
    docType: search.docType === 'INVOICE' ? 'INVOICE' : 'ESTIMATE',
  }),
  beforeLoad: () => {
    const { permissions } = useAuthStore.getState();
    if (permissions.length > 0 && !permissions.includes('estimates:create')) {
      throw redirect({ to: '/dashboard/home' });
    }
  },
  component: NewDocumentTemplatePage,
});

function NewDocumentTemplatePage() {
  const navigate = useNavigate();
  const router = useRouter();
  const { docType } = Route.useSearch();
  const create = useCreateEstimateDocTemplate();

  return (
    <EstimateDocTemplateEditor
      mode="create"
      initialName=""
      initialLayout={
        docType === 'INVOICE' ? buildDefaultInvoiceLayout() : buildDefaultEstimateLayout()
      }
      saving={create.isPending}
      onBack={() => router.history.back()}
      onSave={(name, layout) =>
        create.mutateAsync({ name, docType, ...layout }).then((row) =>
          navigate({
            to: '/dashboard/settings/document-templates/$id',
            params: { id: row.id },
          }),
        )
      }
    />
  );
}
